export const getRoleLabel = (role: string) => {
  switch (role) {
    case 'admin':
      return '店舗管理';
    case 'pharmacist':
      return '服薬指導';
    case 'company_admin':
      return '本部管理';
    case 'clerk':
      // FIXME: Figmaから見つけられず・・・
      return '事務';
    default:
      return '不明';
  }
};
